import { FrequentlyAskedQuestions, SendApplication, ContactWithUs } from '@pages/help/containers';
import { HasPermission } from '@shared/components';
import { useTranslation } from 'react-i18next';
import { Typography } from '@ui/components';
import { FC } from 'react';

export const Help: FC = () => {
  const { t } = useTranslation();

  return (
    <HasPermission permissionFeature="HELP" permissionType="READ" redirect>
      <Typography className="py-2" variant="h300" element="h1">
        {t('HELP.HELP')}
      </Typography>

      <section className="mt-6 grid xl:grid-cols-3 gap-6">
        <FrequentlyAskedQuestions className="xl:col-span-3" />

        <HasPermission permissionFeature="HELP_SEND_A_TICKET" permissionType="WRITE">
          <SendApplication className="xl:col-span-2" />
        </HasPermission>
        <ContactWithUs className="xl:col-span-1" />
      </section>
    </HasPermission>
  );
};
